import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentDialogVisibilityBannerDropdownTrigger from './VeltCommentDialogVisibilityBannerDropdownTrigger/VeltCommentDialogVisibilityBannerDropdownTrigger';
import VeltCommentDialogVisibilityBannerDropdownContent from './VeltCommentDialogVisibilityBannerDropdownContent/VeltCommentDialogVisibilityBannerDropdownContent';
import { transformWireframeProps } from '../../../../utils/propUtils';
;
var VeltCommentDialogVisibilityBannerDropdown = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-visibility-banner-dropdown-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogVisibilityBannerDropdown.Trigger = VeltCommentDialogVisibilityBannerDropdownTrigger;
VeltCommentDialogVisibilityBannerDropdown.Content = VeltCommentDialogVisibilityBannerDropdownContent;
export default VeltCommentDialogVisibilityBannerDropdown;
